import { FC, Key, useContext, useEffect, useMemo, useRef } from 'react';
import ZoomContext from '../../../context/zoom-context';
import ZoomMediaContext from '../../../context/media-context';
import { useSegmentedZoomRecorder } from '../../../hooks/useVideoRecorder';
import { RecordingService } from '../../../service/recording-service';
import { LessonContext } from '../../../context/lesson-context';
import { Box } from '@chakra-ui/react';
import useDebugModeContext from '../../../hooks/useDebugModeContext';
import { isMobile } from '../../../utils/DeviceType';
import { useMount } from '../../../hooks';
import useLogger from '../../../hooks/useLogger';

type Props = {
  isStartedVideo: boolean;
  userId: number;
  userIdentity: string;
  userName: string;
  leaveSession: boolean;
  onVideoTermination: (value: boolean, userId: number) => void;
  onRecVideoAdd: (userId: number) => void;
};
const VideoRecording: FC<Props> = ({
  isStartedVideo,
  userId,
  userIdentity,
  userName,
  leaveSession,
  onVideoTermination,
  onRecVideoAdd
}) => {
  const { mediaStream } = useContext(ZoomMediaContext);
  const zmClient = useContext(ZoomContext);
  const lessonCtx = useContext(LessonContext);
  const recordingService = useMemo(() => new RecordingService(), []);
  const isStartedRef = useRef(false);

  //   const canvasRef = useRef<HTMLCanvasElement>(null);
  const stream = mediaStream;
  // const userId = zmClient.getSessionInfo().userId;
  const session = zmClient.getSessionInfo();
  const debugCtx = useDebugModeContext();
  const logger = useLogger();

  const { isRecording, canvasRef, videoRef, startRecording, stopRecording, videoRecTermination } =
    useSegmentedZoomRecorder({
      stream,
      userId,
      isStartedVideo,
      isMeeting: session.isInMeeting,
      onSegmentAvailable: async (blob, startTime) => {
        await recordingService.upload({
          blob,
          startedAt: startTime,
          lessonInfo: {
            lessonId: lessonCtx.lessonId,
            roomId: lessonCtx.roomId
          },
          targetUserId: `${session.userId}_${userIdentity}`
        });
      },
      leave: leaveSession
    });
  useEffect(() => {
    onVideoTermination(videoRecTermination, userId);
  }, [videoRecTermination]);
  useEffect(() => {
    // console.log(isStartedVideo, isStartedAudio);
    if (isStartedVideo) {
      startRecording();
    } else {
      stopRecording(false);
    }
  }, [isStartedVideo]);

  useEffect(() => {
    if (isStartedRef.current) {
      return;
    }
    onRecVideoAdd(userId);
    startRecording();
    logger.log(userId + '_' + userName + ':start');
    isStartedRef.current = true;
  }, []);
  useEffect(() => {
    if (isStartedRef.current && leaveSession) {
      stopRecording(true);
    }
  }, [leaveSession]);
  return (
    <Box display={debugCtx.recordingPreview ? '' : 'none'} maxWidth={'50vw'} background={'#eaeaea'} id="rec">
      <video-player-container></video-player-container>
      {videoRef.current?.videoWidth} :{videoRef.current?.videoHeight}
      <canvas ref={canvasRef} width={320} height={180} />
      <p>{userName}</p>
      {isRecording ? '停止中' : '録画中'}
      {/* <button onClick={isRecording ? stopRecording : () =>startRecording}>{isRecording ? '停止' : '録画開始'}</button> */}
    </Box>
  );
};
export default VideoRecording;
